import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { Fade, Box } from '@mui/material';
import { germiniDefaultColors } from 'assets/jss/material-dashboard-pro-react';

import Button from 'components/CustomButtons/Button.jsx';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { ModalContainer, PaperContainer, SectionInfo } from './styles';
import { ButtonClose } from 'components/NewButton/styles';
import { IconInfor } from '../../../../assets/icons_svg';

function DocumentAlertModal({
    className,
    handleClose,
    maxWidth,
    minWidth,
    open,
    padding,
    shadow,
    text,
    t,
    type,
    themeColor,
}) {
    const iconColor = themeColor?.visual?.icons?.color || ''

    const renderCloseButton = () => (
        <ButtonClose size="sm" variant="contained" onClick={handleClose}>
            <i className="icon-ico_cancelar" style={{ fontSize: '18px', marginRight: '10px' }} />
            {t('BUTTON_CLOSE')}
        </ButtonClose>
    );

    return (
        <ModalContainer
            open={open}
            className={className}
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            shadow={shadow}
            maxwidth={maxWidth}
            minwidth={minWidth}
            disableEnforceFocus
            style={{
                backdropFilter: 'blur(4px)',
            }}
        >
            <Fade in={open} unmountOnExit>
                <PaperContainer padding={padding || '19px 28px 28px 28px'} maxwidth={maxWidth || '569px'}>
                    <GridContainer  >
                        <GridItem xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {type === 'document' && renderCloseButton()}
                        </GridItem>

                        <GridItem xs={12} style={{ display: 'flex', justifyContent: 'center', }}>
                            <IconInfor sx={{ color: iconColor, fontSize: '70px !important', paddingBottom: '16px' }} />
                        </GridItem>
                    </GridContainer>

                    <GridItem xs={12}>
                        <Box display="flex" justifyContent="center" textAlign="center" width="100%">
                            <SectionInfo sx={{ maxWidth: '400px' }}>{text}</SectionInfo>
                        </Box>

                        <Box display="flex" justifyContent="center" mt={3}>
                            {type === 'document' ? (
                                <Button
                                    size="sm"
                                    variant="contained"
                                    color="greenButtonColor"
                                    onClick={handleClose}
                                >
                                    {t('Confirmo documento')}
                                </Button>
                            ) : (
                                renderCloseButton()
                            )}
                        </Box>
                    </GridItem>
                </PaperContainer>
            </Fade>
        </ModalContainer>
    );
}



export default withTranslation()(DocumentAlertModal);
